import { render, screen } from "@testing-library/react";
import RangeFilter from "./RangeFilter";

test("check rendering range filter", () => {
  render(<RangeFilter onFilterchange={() => {}} />);
  expect(screen.getByText("Date Range")).toBeInTheDocument();
});
